import ChipTaskProcessTypeStatus, {
    type StatusChipProps,
} from '@/components/chip/ChipTaskProcessTypeStatus';

import { TaskProcessTypeEnum } from '@/types/enums/task-process-type.enum';
import { t } from '@/utils/lang';

export const TaskProcessTypeOptions = (): {
    label: string;
    value: TaskProcessTypeEnum;
}[] => [
    {
        label: t('Task yêu cầu', 'TaskProcessType'),
        value: TaskProcessTypeEnum.NEW,
    },
    {
        label: t('Task lặp lại', 'TaskProcessType'),
        value: TaskProcessTypeEnum.RECURRING,
    },
    {
        label: t('Task phát sinh', 'TaskProcessType'),
        value: TaskProcessTypeEnum.AD_HOC,
    },
];

export const getTaskProcessTypeStatusData = (props: StatusChipProps) => {
    return ChipTaskProcessTypeStatus(props);
};

export const getTaskProcessTypeOptionsFilter = (isFilter?: boolean) => {
    const enumValues = TaskProcessTypeEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getTaskProcessTypeStatusData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: t(data.label, 'TaskProcessType'),
        });
    });

    return options;
};
